<template>
  <FixedPopupVue>
    <div class="moondayFilter">
      <div class="moondayFilter__title">筛选星座月亮日</div>
      <div class="moondayFilter__option" v-if="moondayFilterTarget">
        <div class="moondayFilter__option__status">
          筛选条件：
          {{ moondayFilterTarget.cn }}
        </div>
        <div class="moondayFilter__option__clear" @click="selectHandler(null)">
          清除
        </div>
      </div>
      <div class="moondayFilter__list">
        <div
          class="moondayFilter__list__item"
          v-for="astro in $Astro"
          :key="astro.en"
        >
          <div class="moondayFilter__list__item__pic">
            <img :src="astro.img" alt="" />
          </div>
          <div class="moondayFilter__list__item__title">
            月亮{{ astro.cn }}日
          </div>
          <div
            class="moondayFilter__list__item__select"
            :class="{
              active: moondayFilterTarget && astro.en == moondayFilterTarget.en,
            }"
            @click="selectHandler(astro)"
          >
            <img
              src="../../assets/月亮日記/icon-ok-active.svg"
              v-if="moondayFilterTarget && astro.en == moondayFilterTarget.en"
            />
            <img src="../../assets/月亮日記/icon-ok.svg" v-else />
          </div>
        </div>
      </div>
    </div>
  </FixedPopupVue>
</template>

<script>
import FixedPopupVue from "../Fixed_popup.vue";
export default {
  components: {
    FixedPopupVue,
  },
  data() {
    return {};
  },
  computed: {
    moondayFilterTarget() {
      return this.$store.getters.moondayFilterTarget;
    },
  },
  methods: {
    selectHandler(Obj) {
      this.$store.commit("setMoondayFilterTarget", Obj);
      this.$emit("close");
      this.$emit("refresh");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_mixin.scss";

.moondayFilter {
  margin: 40px auto;
  padding: 36px 12px;
  width: 520px;
  height: calc(100vh - 80px);
  max-height: 780px;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 50px;
  background: var(--vi-white, #f0f2f4);
  box-shadow: 4px 4px 25px 0px rgba(0, 0, 0, 0.3), -4px -4px 10px 0px rgba(238, 109, 175, 0.22),
    -4px -4px 16px 0px rgba(238, 109, 175, 0.22);
  @include mobile {
    padding: 32px 8px;
    width: 326px;
    max-width: calc(100vw - 48px);
  }
  &__title {
    color: #17445c;
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: 1.92px;
    margin-bottom: 32px;
    @include mobile {
      font-size: 20px;
    }
  }
  &__option {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 33px;
    margin-bottom: 32px;
    @include mobile {
      margin-bottom: 16px;
      padding: 0 24px;
    }
    &__status {
      color: #868686;
      font-size: 18px;
      @include mobile {
        font-size: 14px;
      }
    }
    &__clear {
      color: #ab956c;
      font-size: 18px;
      text-decoration: underline;
      cursor: pointer;
      @include mobile {
        font-size: 14px;
      }
    }
  }
  &__list {
    width: 100%;
    height: calc(100vh - 80px - 196px);
    height: 584px;
    overflow: auto;
    @include scroll-primary;
    padding: 0 33px;
    @include mobile {
      margin-bottom: 16px;
      padding: 0 24px;
    }
    &__item {
      width: 100%;
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      &__pic {
        width: 76px;
        height: 76px;
        border-radius: 50%;
        box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22), -1px -1px 4px rgba(238, 109, 175, 0.22),
          2px 2px 6px rgba(0, 0, 0, 0.25);
        padding: 8px;
        @include mobile {
          width: 56px;
          height: 56px;
          padding: 4px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__title {
        margin-left: 20px;
        color: #767676;
        font-size: 20px;
        @include mobile {
          margin-left: 16px;
          font-size: 16px;
        }
      }
      &__select {
        margin-left: auto;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22), -1px -1px 4px rgba(238, 109, 175, 0.22),
          2px 2px 6px rgba(0, 0, 0, 0.25);
        cursor: pointer;
        padding: 4px;
        @include mobile {
          width: 24px;
          height: 24px;
          padding: 3px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        &.active {
          background-color: #798da5;
        }
      }
    }
  }
}
</style>
